import './optional-questions.scss';
import React from 'react';
import { slug } from 'researcher/helpers/slug';
import Question from './Question';
var OptionalQuestions = function OptionalQuestions(_ref) {
  var answers = _ref.answers,
    OptionalQuestionsWrapper = _ref.optionalQuestionsWrapper,
    optionalQuestions = _ref.optionalQuestions,
    questionsRequiringPreviousSelection = _ref.questionsRequiringPreviousSelection,
    methods = _ref.methods;
  if (optionalQuestions.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(OptionalQuestionsWrapper, null, optionalQuestions.map(function (question) {
    return /*#__PURE__*/React.createElement(Question, {
      answers: answers,
      key: question.label,
      name: "answers[".concat(question.label, "]"),
      question: question,
      questionsRequiringPreviousSelection: questionsRequiringPreviousSelection,
      methods: methods,
      id: slug(question.label)
    });
  }));
};
export default OptionalQuestions;